export interface ErpLoginResponse {
  user?: Record<string, unknown>;
  _token?: string;
  token?: string;
}

/** Enregistre la session ERP après POST /api/users/login (_token JWT). */
export function persistErpLoginSession(data: ErpLoginResponse): void {
  const jwt = String(data._token || data.token || '').trim();
  const user = data.user;
  if (!user) {
    return;
  }

  if (jwt) {
    localStorage.setItem('token', jwt);
    localStorage.setItem('erp_token', jwt);
    localStorage.setItem('currentUser', JSON.stringify({ ...user, token: jwt }));
  } else {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  localStorage.setItem('users', JSON.stringify(user));
}

/** JWT ERP (gateway /api/users/*) — pas confondre avec users.id ni token logiciel caisse. */
export function getErpJwtToken(): string | null {
  const candidates: string[] = [];

  try {
    const raw = localStorage.getItem('currentUser');
    if (raw) {
      const user = JSON.parse(raw) as { token?: string };
      if (user?.token) {
        candidates.push(String(user.token));
      }
    }
  } catch {
    /* ignore */
  }

  for (const key of ['erp_token', 'accessToken', 'token', '_token']) {
    const v = localStorage.getItem(key);
    if (v) {
      candidates.push(v);
    }
  }

  for (const value of candidates) {
    const t = String(value || '').trim();
    if (t && t.includes('.')) {
      return t;
    }
  }

  return null;
}

export function isErpJwtPresent(): boolean {
  return !!getErpJwtToken();
}

export function getErpUserId(): number | null {
  try {
    const raw = localStorage.getItem('currentUser');
    if (!raw) {
      return null;
    }
    const id = Number(JSON.parse(raw)?.id);
    return Number.isFinite(id) && id > 0 ? id : null;
  } catch {
    return null;
  }
}

export function clearErpAuthSession(): void {
  localStorage.removeItem('currentUser');
  localStorage.removeItem('users');
  localStorage.removeItem('token');
  localStorage.removeItem('erp_token');
}
